import clsx from "clsx";
import { startCase } from "lodash";

import { Image } from "@components";
import Typography from "@components/typography/Typography";

import styles from "./header.module.scss";

type Props = {
  classification?: string;
  label?: string;
  type?: "url" | "domain" | "ip";
};

const Classification = ({
  classification = "unknown",
  label,
  type = "url"
}: Props) => (
  <div className={clsx(styles.image_wrapper, styles[`${classification}`])}>
    <Image
      alt={`Threat status: ${classification}`}
      className={styles.image}
      type="NETWORK_CLASSIFICATION"
      fileType="svg"
      name={`${type}-network-classification-image-${classification}`}
    />
    <Typography
      className={`threat-status--${classification} uppercase`}
      variant="body2"
      style={{ fontWeight: 800, lineHeight: "15px" }}
      tag="div"
      data-testid="nti_header_classification"
    >
      {label ?? startCase(classification)}
    </Typography>
  </div>
);

export default Classification;
